import apiClient from '@/plugins/axios';

export default {
	getAreas(params) {
		let query = '?';
		Object.entries(params).forEach(([key, value]) => {
			if (key === 'currentPage') {
				key = 'pageNumber';
			}

			query += value || value === false ? `${key}=${value}&` : '';
		});

		return apiClient.get(`v1/Area${query}`);
	},

	getArea(areaId) {
		return apiClient.get(`v1/Area/${areaId}`);
	},

	createArea(area) {
		return apiClient.post('v1/Area', area);
	},

	updateArea(area) {
		var areaId = area.id;

		return apiClient.put(`v1/Area/${areaId}`, area);
	},

	deleteArea(areaId) {
		return apiClient.delete(`v1/Area/${areaId}`);
	}
};
